import React, { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectKnownMailboxes } from 'selectors/mailboxes/selectKnownMailboxes'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import DropdownMenu from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownMenu'
import {
  button,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { ArrowDown } from '@groovehq/internal-design-system/lib/assets/icons'
import ListenToKeyboard from 'components/ListenToKeyboard'
import { styles } from './styles'

const allOption = { id: 'all', name: `All ${app.t('mailboxes')}` }
const menuOffset = [0, 10]

const MailboxSearchFilter = ({ selectedMailbox, focused, onSelectMailbox }) => {
  const [visible, setVisible] = useState(false)
  const mailboxes = useSelector(selectKnownMailboxes)
  const mailbxesIncludingAllOption = useMemo(() => [...mailboxes, allOption], [
    mailboxes,
  ])

  const handleSelectMailbox = useCallback(
    (_id, mailbox) => {
      onSelectMailbox(mailbox, {
        shouldFocusSearchBox: visible,
      })
    },
    [onSelectMailbox, visible]
  )

  return (
    <>
      {visible && <ListenToKeyboard hijack={ListenToKeyboard.DROPDOWN} />}
      <Dropdown
        hasMinWidth
        strategy="fixed"
        portal="#overlays"
        onSelect={handleSelectMailbox}
        selectedKey={selectedMailbox?.id || allOption.id}
        onVisibleChange={setVisible}
        offset={menuOffset}
        overlay={
          <DropdownMenu>
            {mailbxesIncludingAllOption.map(mailbox => (
              <DropdownMenu.Item
                key={mailbox.id}
                itemKey={mailbox.id}
                item={mailbox}
              >
                {mailbox.name}
              </DropdownMenu.Item>
            ))}
          </DropdownMenu>
        }
      >
        <button
          css={[
            button.styles.preflight,
            !focused && text.styles.textWhite,
            !focused && styles.mailboxFilterButtonLight,
            styles.mailboxFilterButton,
          ]}
        >
          <span className="grui px-5 flex items-center">
            <span className="grui truncate">
              {selectedMailbox?.name || allOption.name}
            </span>
            <ArrowDown className="grui ml-5" />
          </span>
        </button>
      </Dropdown>
    </>
  )
}

export default MailboxSearchFilter
